export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "sales_yesterday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ventes hier"])},
        "sales_this_month": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ventes ce mois"])},
        "sales_today": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ventes aujourd'hui"])},
        "active_stores": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasins actifs"])},
        "remuneration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rémunération"])},
        "objective_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objectif"])}
      },
      "en": {
        "sales_yesterday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales yesterday"])},
        "sales_this_month": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales this month"])},
        "sales_today": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales today"])},
        "active_stores": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active stores"])},
        "remuneration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remuneration"])},
        "objective_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objective"])}
      }
    }
  })
}
